/**
 * PostHog analytics plugin
 *
 * Integrates with the posthog-js library that is initialized in index.tsx
 *
 * PostHog is identified in app.root.tsx after user details are available.
 *
 * Sends track and page events to PostHog using posthog.capture()
 */
import posthog from 'posthog-js'

const posthogPlugin = {
  name: 'posthog',

  /**
   * Track custom events in PostHog
   * @param {object} pluginApi - Plugin API object containing payload
   */
  track: ({ payload }) => {
    if (typeof window === 'undefined' || !posthog.__loaded) {
      return
    }

    try {
      posthog.capture(payload.event, payload.properties)
    } catch (error) {
      console.error('PostHog track error:', error, payload)
    }
  },

  /**
   * Track page views in PostHog
   * @param {object} pluginApi - Plugin API object containing payload
   */
  page: ({ payload }) => {
    if (typeof window === 'undefined' || !posthog.__loaded) {
      return
    }

    try {
      posthog.capture('$pageview', {
        ...payload.properties,
        $current_url: window.location.href,
      })
    } catch (error) {
      console.error('PostHog page error:', error, payload)
    }
  },

  /**
   * Check if PostHog is loaded and available
   * @returns {boolean}
   */
  loaded: () => {
    return typeof window !== 'undefined' && posthog.__loaded
  },
}

export default posthogPlugin
